import Swiper, { Navigation, Pagination } from 'swiper';
import './main.scss';
import 'tippy.js/dist/tippy.css';
//import 'trix';
import '@rails/actiontext';

import * as Turbo from '@hotwired/turbo';
import Alpine from 'alpinejs';
import tippy from 'tippy.js';
import SlideshowManager from './script/components/SlideshowManager';
import initCartManager from './script/components/cart-management';
import handleContainerClick from './script/components/LinksManager';
import handleFormSubmitOnChange from './script/components/FormSubmitOnChange';
// import MegaNavigationManager from './script/components/MegaNavigationManager';
import initToggles from './script/components/toggle-module';
import initSwiper from './script/components/initSwiper';
import initConfirmButtons from './script/components/confirm';
import ScrollToNamedAnchorManager from './script/components/ScrollToNamedAnchorManager';
import ToggleTargets from './script/components/toggleTargets';
import { lockBodyScroll, unlockBodyScroll } from './script/components/scrollLock';
window.lockBodyScroll = lockBodyScroll;
window.unlockBodyScroll = unlockBodyScroll;
Turbo.start();
window.Alpine = Alpine;
Alpine.start();
let slideshowManager;
import { application } from '../controllers';

console.log("application.js")

if (!window.tippyInitialized) {
  tippy('[title]', {
    content: (reference) => {
      const title = reference.getAttribute('title');
      reference.removeAttribute('title');
      return title;
    },
  });
  window.tippyInitialized = true; // Prevent re-initialization
}

function handlePopupLinks() {
  const popupLinks = document.querySelectorAll('[data-open-in-popup]');
  popupLinks.forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const url = this.getAttribute('href');
      window.open(url, '_blank', 'width=600,height=600');
    });
  });
}

document.addEventListener('turbo:load', () => {
  new ToggleTargets();
});


const initPopup = function (){
  const popup = document.querySelector('[data-popupopen]');
  if(!popup){return}
  popup.setAttribute('data-popupopen', 'true');
  const close = popup.querySelector('[data-close-popup]');
  close.addEventListener('click',()=>{
    popup.setAttribute('data-popupopen', 'false');
  })

}

const turboEvents = ['turbo:frame-load', 'turbo:render', 'turbo:load'];
turboEvents.forEach((eventName) => {
  document.addEventListener(eventName, () => {
    handleFormSubmitOnChange();
    initToggles();
    initPopup();
  });

});



document.addEventListener('turbo:load', () => {
  initCartManager();
  handleContainerClick();
  new ScrollToNamedAnchorManager();
  initSwiper();
  initConfirmButtons();


  if (slideshowManager) clearInterval(slideshowManager.intervalId);
  slideshowManager = new SlideshowManager();
});

document.addEventListener('turbo:load', () => console.log('[turbo] load'));
document.addEventListener('turbo:render', () => console.log('[turbo] render'));


document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-open-in-popup]');
  if (link) {
    event.preventDefault();
    window.open(link.href, '_blank', 'width=900,height=600');
  }
});

if (0) {
  const observer = new MutationObserver(initToggles);
  observer.observe(document.getElementById('cart'), {
    childList: true,
    subtree: true,
  });
}

console.log('howdy from application.js');


